import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';

export const StyledChatPane = styled(Box).attrs({
  height: '100%',
  border: '1px solid',
  borderColor: 'lightLineDivider',
  borderRadius: '5px',
  overflow: 'hidden',
})``;

export const StyledAlertPane = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  width: 480px;
  background: ${props => props.theme.colors.background};
  ${({ theme }) => {
    if (theme.colors.name !== 'light') {
      return `
      background: linear-gradient(
        0deg,
        #0b1928 0%,
        #293648 50%,
        #0b1928 100%
      );
      backdrop-filter: blur(15px);
      `;
    } else {
      return `
      background: linear-gradient(
        0deg,
        #FFFFFF 0%,
        rgba(228, 230, 231, 0.5) 50%,
        #FFFFFF 100%
      );
      backdrop-filter: blur(15px);
      `;
    }
  }}
  .Resizer {
    background: inherit;
  }
`;
